import React, { useState, useEffect } from "react";

import Styled from "./TabsStyles";
import { ColorSAP } from "../../ontego-ui";

export const Tabs = (props) => {
  const { containerId, tabItems, activeIndex, handleChangeIndex, style } =
    props;

  const [internalIndex, setInternalIndex] = useState(activeIndex);

  useEffect(() => {
    setInternalIndex(activeIndex);
  }, [activeIndex]);

  const onChangeIndex = (index) => () => {
    setInternalIndex(index);
    handleChangeIndex(index);
  };

  return (
    <div
      id={containerId}
      style={{ display: "flex", alignItems: "center", ...style }}
    >
      {tabItems.map((tab, index) => {
        return (
          <Styled.FunctionBoxContainer
            style={{
              borderBottom:
                internalIndex === index
                  ? `1px solid ${ColorSAP.primary[70]}`
                  : "1px solid transparent",
            }}
            key={`${tab.id}-${index}`}
            onClick={onChangeIndex(index)}
          >
            {tab.label}
          </Styled.FunctionBoxContainer>
        );
      })}
    </div>
  );
};

export default React.memo(Tabs);
